module.exports = __webpack_public_path__ + "static/media/posts.74802563.svg";